<div [pTooltip]="str" [autoHide]="false" [class]="strClass">{{ text }}</div>
